// @flow

import React, { type Node } from 'react';
import { useIncomingPayment, getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { useCurrentReceipt, getLocalTax } from '@tectonics/prs/receipts';
import { getLocalTaxCodeFromString, amountToCurrencyString } from '@tectonics/prs/money';
import { Portal } from '@tectonics/commons/portal';

import { getMoneyFormat } from '../../../utils/money-format';
import { Empty } from '../../../atoms';
import { Tooltip } from '../../../molecules/tooltip';
import {areLocalTaxesAbsorbed} from '../../../../../prs/merchant/config/are-local-taxes-absorbed';

export function IofDisplay(): Node {
  const incomingPayment = useIncomingPayment();
  const [selectedPaymentMethod] = useUserInputValue('selectedPaymentMethod');
  const currentReceipt = useCurrentReceipt();

  const tax = getLocalTax(currentReceipt, getLocalTaxCodeFromString('iof'));
  const localTaxesAbsorbed = areLocalTaxesAbsorbed(getMerchant(incomingPayment));

  const id = 'bromelia-iof-display';

  if (!selectedPaymentMethod || !tax || localTaxesAbsorbed) {
    return (
      <Portal id={id} tagName="tr">
        <Empty />
      </Portal>
    );
  }

  const decimalFormat = getMoneyFormat(getCountry(incomingPayment));
  const formatAmount = amountToCurrencyString(decimalFormat);
  const amount = formatAmount(tax.amount);

  return (
    <Portal id={id}>
      <th className="total-line__name" scope="row">
        <span style={{ marginRight: 8 }}>IOF</span>
        <div style={{ position: 'relative', display: 'inline-block', verticalAlign: 'middle', marginLeft: 8 }}>
          <Tooltip insideField={false}>Imposto federal no Brasil cobrado sobre operações financeiras.</Tooltip>
        </div>
      </th>
      <td className="total-line__price">
        <span className="order-summary__emphasis">{amount}</span>
      </td>
    </Portal>
  );
}
